module.exports = __webpack_public_path__ + "img/avatar-s-4.d067623e.jpg";